// src/router/notificacoes.js

const notificacoesBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Notificações',
        to: 'Notificacoes'
    }
]

export default [
    {
        path: '/notificacoes',
        name: 'Notificacoes',
        component: () => import('@/views/Notificacoes/NotificacaoListPage.vue'),
        meta: {
            title: 'Notificações',
            breadcrumb: notificacoesBreadCrumb
        },
    },
    {
        path: '/notificacoes/novo',
        name: 'NotificacoesNovo',
        component: () => import('@/views/Notificacoes/NovoNotificacaoPage.vue'),
        meta: {
            title: 'Nova Notificação',
            breadcrumb: [
                ...notificacoesBreadCrumb,
                {
                    label: 'Novo Cliente',
                    to: 'ClienteNovo'
                }
            ]
        }
    },
    {
        path: '/notificacoes/:id/edit',
        name: 'NotificacaoEdit',
        component: () => import('@/views/Notificacoes/NovoNotificacaoPage.vue'),
        meta: {
            title: 'Detalhes da Notificação',
            breadcrumb: [
                ...notificacoesBreadCrumb,
                {
                    label: 'Nova Notificacao',
                    to: 'NotificacaoNovo'
                }
            ]
        }
    }

];
